export * from './lib/table.module';
export * from './lib/components/table-kebab-button.module';

export { AccredibleTableColumn, AccredibleTableColumnType } from './lib/table.model';
export { AccredibleTableComponent } from './lib/table.component';
